import SortDirectionControl from './SortDirectionControl';
import React from 'react';
import { Popover, Button, Input, Icon, Checkbox } from 'antd';

export const ImageId = ({
  onChange,
  params,
  isExactMatch,
  setIsExactMatch,
  hasExactMatch
}) => {
  const changeSort = () => {
    let order;

    if (params?.order === '') {
      order = 'asc';
    } else if (params?.order === 'asc') {
      order = 'desc';
    } else {
      order = '';
    }

    onChange({ ...params, order });
  };

  const content = (
    <>
      <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center' }} onClick={changeSort}>
        <b style={{ marginRight: 5 }}>Sort:</b>
        <SortDirectionControl order={params?.order} />
      </div>

      {hasExactMatch && (
        <div style={{ marginBottom: 8 }}>
          <Checkbox
            checked={isExactMatch}
            onChange={(e) => {
              if (e.target.checked) {
                setIsExactMatch(true);
              } else {
                setIsExactMatch(false);
              }
            }}
          >
            Exact match
          </Checkbox>
        </div>
      )}

      <Input
        value={params?.value}
        placeholder='Image ID'
        style={{ width: '150px' }}
        onChange={(e) => {
          onChange({ ...params, value: e.target.value });
        }}
        allowClear
      ></Input>
    </>
  );

  return (
    <Popover content={content} title='Image Id' trigger='click'>
      <Button className='sighting-filter' style={{ width: '10%' }}>
        Image Id
        <Icon type='down' style={{ color: '#d9d9d9' }} />
      </Button>
    </Popover>
  );
};
